import React from 'react'

const Header = () => {
	return(
		<nav>
        	 <div id="help-modal" className="modal">
		        <div className="modal-content">
		          <span className="close" id="close-help">&times;</span>

		          <p>Guess the WORDLE in 6 tries.</p>

		          <p>
		            Each guess must be a valid 5 letter word. Hit the enter button to
		            submit.
		          </p>

		          <p>
		            After each guess, the color of the tiles will change to show how
		            close your guess was to the word.
		          </p>

		          <img src="examples.png" id="examples" />

		          <hr />
		          <p>A new WORDLE will be available each day!</p>
		        </div>
		      </div>
        	<h1>Al-Qurdle</h1>
        	<div id="stats-modal" className="modal">
		        <div className="modal-content">
		          <span className="close" id="close-stats">&times;</span>

		          <h2>STATISTICS</h2>

		          <h3><strong>Total</strong>: <span id="total-played"></span></h3>

		          <h3><strong>Wins</strong>: <span id="total-wins"></span></h3>

		          <h3><strong>Win %</strong>: <span id="win-pct"></span></h3>

		          <h3>
		            <strong>Current Streak</strong>: <span id="current-streak"></span>
		          </h3>
		        </div>
		      </div>
      	</nav>
		)
}

export default Header;